import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  openingStage: {
    id: `app.containers.WorkflowEditor.components.Rules.Action.components.MoveToPosition.openingStage`,
    defaultMessage: 'Opening Stage',
  },
});
